import { useMutation, useQuery } from "@tanstack/react-query";
import { deleteApi, get, post, put } from "../../api/client";
import { dataToOptionsTransformer } from "../../Services/transformer/dataToOptionsTransformer";
import { BranchPayloadInterface } from "../../Constants/Interfaces/payloadInterface/BranchPayload.interface";
import queryClient from "../../config/queryClient";

export const BRANCH_KEY = {
  BRANCH_LIST: "BRANCH_LIST",
  BRANCH_LIST_OPTIONS: "BRANCH_LIST_OPTIONS",
};
export const useGetSchoolBranches = () =>
  useQuery([BRANCH_KEY.BRANCH_LIST], () =>
    get({ url: "api/v1/school-branch" })
  );

export const useGetSchoolBranchesOptions = () => {
  return useQuery([BRANCH_KEY.BRANCH_LIST_OPTIONS], () => {
    const classOptions = get({ url: "api/v1/school-branch" }).then(
      (classes) => {
        return dataToOptionsTransformer({
          dataToTransform: classes,
          value: "id",
          text: "name",
        });
      }
    );
    return classOptions;
  });
};

export const useAddBranch = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => unknown;
  onError: (error: any) => unknown;
}) => {
  return useMutation(
    (body: BranchPayloadInterface) => {
      return post({ url: "/api/v1/school-branch/register", body });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [BRANCH_KEY.BRANCH_LIST],
        });
        onSuccess();
      },
      onError: (error) => {
        onError(error);
      },
    }
  );
};

export const useUpdateBranch = ({
  onSuccess,
  onError,
  branchId,
}: {
  onSuccess: () => unknown;
  onError: (error: any) => unknown;
  branchId: number;
}) => {
  return useMutation(
    (body: BranchPayloadInterface) => {
      return put({ url: `/api/v1/school-branch/${branchId}`, body });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [BRANCH_KEY.BRANCH_LIST],
        });
        onSuccess();
      },
      onError: (error) => {
        onError(error);
      },
    }
  );
};

export const useRemoveBranch = ({
  onSuccess,
  onError,
}: {
  onSuccess: () => unknown;
  onError: (error: any) => unknown;
}) => {
  return useMutation(
    (branchId: number) => {
      return deleteApi(`/api/v1/school-branch/${branchId}`);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [BRANCH_KEY.BRANCH_LIST],
        });
        onSuccess();
      },
      onError: (error) => {
        onError(error);
      },
    }
  );
};
